export const ApplicationDTO = {
    list: (raw) => ({
        publicId: raw.publicId,
        fullName: `${raw.firstName} ${raw.lastName}`,
        email: raw.email,
        phone: raw.contact
            ? `${raw.contact.countryCode} ${raw.contact.phoneNumber}`
            : raw.phone,
        status: raw.status,
        applicationChannel: raw.applicationChannel || "PHYSICAL",
        createdAt: raw.createdAt,
    }),

    detail: (raw) => ({
        publicId: raw.publicId,
        applicationChannel: raw.applicationChannel,

        personal: {
            firstName: raw.personal?.firstName,
            lastName: raw.personal?.lastName,
            identityDocumentType: raw.personal?.identityDocumentType,
            tckn: raw.personal?.tckn,
            passportNumber: raw.personal?.passportNumber,
            gender: raw.personal?.gender,
            birthDate: raw.personal?.birthDate,
            birthPlace: raw.personal?.birthPlace,
        },

        contact: {
            email: raw.contact?.email,
            phone: raw.contact?.fullPhone,
            countryCode: raw.contact?.countryCode,
            phoneNumber: raw.contact?.phoneNumber,
            city: raw.contact?.city,
            address: raw.contact?.address,
        },

        education: {
            profession: raw.education?.profession,
            lastGraduatedSchool: raw.education?.lastGraduatedSchool,
            hasSportsExperience: raw.education?.hasSportsExperience,
            hasPreviousFootballEducation: raw.education?.hasPreviousFootballEducation,
        },

        motivation: {
            participationMotivation: raw.motivation?.participationMotivation,
            whyFootex: raw.motivation?.whyFootex,
            footballMeaning: raw.motivation?.footballMeaning,
            lifeGoal: raw.motivation?.lifeGoal,
        },

        status: {
            value: raw.status?.current,
            isAccepted: raw.status?.isApproved,
            statusUpdatedAt: raw.timestamps?.statusUpdatedAt,
            reviewedAt: raw.review?.reviewedAt,
            reviewedBy: raw.review?.reviewedBy,
            approvedAt: raw.review?.approvedAt,
            approvedBy: raw.review?.approvedBy,
            rejectedAt: raw.review?.rejectedAt,
            rejectedBy: raw.review?.rejectedBy,
            withdrawnAt: raw.review?.withdrawnAt,
            withdrawnBy: raw.review?.withdrawnBy,
        },

        approvedNote: raw.review?.approvedNote || null,
        rejectedNote: raw.review?.rejectedNote || null,
        withdrawnNote: raw.review?.withdrawnNote || null,

        video: raw.video
            ? {
                url: raw.video.url,
                mimeType: raw.video.mimeType,
                size: raw.video.size,
                bucket: raw.video.bucket,
                key: raw.video.key,
            }
            : null,

        timestamps: {
            createdAt: raw.timestamps?.createdAt,
            updatedAt: raw.timestamps?.updatedAt,
        },

        createdAt: raw.timestamps?.createdAt,
    }),

    select: (raw) => ({
        publicId: raw.publicId,
        label: `${raw.firstName} ${raw.lastName}`,
    }),
};
